import { render, staticRenderFns } from "./upsell-amount-enum.vue?vue&type=template&id=9d908820&"
import script from "./upsell-amount-enum.vue?vue&type=script&lang=js&"
export * from "./upsell-amount-enum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports